// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBn-YzAJ6i-UD3Dka20Wafo2d7KERDmrsc",
  authDomain: "footprints-b291f.firebaseapp.com",
  projectId: "footprints-b291f",
  storageBucket: "footprints-b291f.appspot.com",
  messagingSenderId: "1021298263694",
  appId: "1:1021298263694:web:665c7dc79375382070ebdf",
  measurementId: "G-6E2PK0EE2P"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);